import { render, staticRenderFns } from "./EmojiRating.vue?vue&type=template&id=56d684bb&"
import script from "./EmojiRating.vue?vue&type=script&lang=ts&"
export * from "./EmojiRating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports